// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InstagramEmbed":"bay_a","InstagramEmbed__mask":"bay_b bhs_bi bhs_bo bhs_wz"};